import styled from 'styled-components';
import colors from '../../../config/colors';

const BackButton = styled.button`
  display: inline-block;
  margin-right: 12px;

  svg {
    display: block;
    width: 24px;
    height: 24px;
    opacity: 1;
    fill: ${colors.WHITE_COLOR};
    stroke: ${colors.PURPLE_COLOR};
    transition: all 100ms ease-in-out;
  }

  &:hover {
    opacity: 0.7;
  }
`;

export default BackButton;
